import {
	ToothDecayType,
	ToothPathology,
	ToothSurface,
} from '../../../../graphql/graphql';

export default function separateDecayTypeSurfaces(pathology: ToothPathology) {
	const primaryDecaySurfaces: ToothSurface[] = [];
	const secondaryDecaySurfaces: ToothSurface[] = [];

	pathology.decays?.forEach(decay => {
		const decayType = decay?.values?.type;

		if (!decayType) {
			return;
		}

		if (decayType === ToothDecayType.Primary) {
			primaryDecaySurfaces.push(...decay.surfaces);
		} else {
			secondaryDecaySurfaces.push(...decay.surfaces);
		}
	});

	return {
		primaryDecaySurfaces: [...new Set(primaryDecaySurfaces)],
		secondaryDecaySurfaces: [...new Set(secondaryDecaySurfaces)],
	};
}
